import PropTypes from 'prop-types';

import LinkedEvent from './LinkedEvent';

const LinkedEvents = ({ linked_events }) => {
  const totalLinkedEvents = linked_events.length;

  if (!totalLinkedEvents) {
    return null;
  }

  const events = linked_events.map((e) => (
    <LinkedEvent key={`event_${e.get('id')}`} {...e.toJS()} />
  ));

  return (
    <section className="soft-half--bottom soft-double-half bordered--sides bordered--bottom">
      <h2 className="h2">
        {I18n.t('web.topics.linked_events', { count: totalLinkedEvents })}
      </h2>
      <div className="linked_events__container">{events}</div>
    </section>
  );
};

LinkedEvents.propTypes = {
  linked_events: PropTypes.array,
};

LinkedEvents.defaultProps = {
  linked_events: [],
};

export default LinkedEvents;
